import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center px-6">
        <h1 className="text-7xl font-bold text-slate-300">404</h1>
        <h2 className="mt-4 text-2xl font-semibold text-slate-700">Page Not Found</h2>
        <p className="mt-2 text-slate-500">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link
          to="/dashboard"
          className="mt-6 inline-block px-6 py-3 bg-[#EF4023] text-white font-medium rounded-lg hover:bg-[#d93518] transition-colors"
        >
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
}
